import { Component } from '@angular/core';

@Component({
  selector: 'app-toast',
  template: `
    <div *ngIf="true" class="toast" [ngClass]="{'show': isVisible}">
      <p class="title">{{title}}</p>
      <p class="message">{{ message }}</p>
    </div>
  `,
  styles: [`
    .toast {
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      padding: 16px;
      background-color:  rgba(32, 39, 61, 1) ;
      color: white;
      border-radius: 4px;
      transition: opacity 0.5s ease;
      opacity: 0;
      p{
        margin: 0;

        &.title {
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 10px;
        }

        &.message {
          font-weight: normal;
          font-size: 16px
        }
      }
    }

    .toast.show {
      opacity: 1;
    }
  `]
})
export class ToastComponent {
  title: string = '';
  message: string = '';

  isVisible: boolean = false;

  show(title: string, message: string) {
    this.title = title;
    this.message = message;
    this.isVisible = true;
    console.log(title, message);


    setTimeout(() => {
      this.isVisible = false;
    }, 3000);
  }
}



// WEBPACK FOOTER //
// ./src/components/toast/toast.ts